import { Injectable } from '@angular/core';
import { SourceIdEnum } from '../Models/sourceIdEnumModel';

@Injectable({
  providedIn: 'root',
})
export class SourceIdResolverService {
  resolve(url: string): SourceIdEnum {
    const path = String(url || '').split(/[?#]/, 1)[0].toLowerCase();

    if (/iit-study-material|resources|resource-details/.test(path)) return SourceIdEnum.Resources;
    if (/forum|forums/.test(path)) return SourceIdEnum.Forum;
    if (/contact-us/.test(path)) return SourceIdEnum.ContactUs;
    if (/free-demo|centers/.test(path)) return SourceIdEnum.FreeDemo;
    if (/crash-course/.test(path)) return SourceIdEnum.CrashCourse;
    if (/test-series/.test(path)) return SourceIdEnum.TestSeries;
    if (/one-to-one/.test(path)) return SourceIdEnum.OneToOne;
    if (/payment-credit-debit|package/.test(path)) return SourceIdEnum.Package;
    if (/upcoming-examinations|exam-alert/.test(path)) return SourceIdEnum.ExamAlerts;
    if (/revision-note/.test(path)) return SourceIdEnum.RevisionNote;
    if (/rank-calculator/.test(path)) return SourceIdEnum.RankCalculator;
    if (/college-predictor/.test(path)) return SourceIdEnum.JeeMainCollegePredictor;
    if (/bitsat/.test(path)) return SourceIdEnum.BITSATRankCalculator;
    if (/jee-advance/.test(path)) return SourceIdEnum.JEEAdvanceRankCalculator;
    if (/aipmt|neet/.test(path)) return SourceIdEnum.NeetPages;
    if (/news/.test(path)) return SourceIdEnum.News;
    if (/paper/.test(path)) return SourceIdEnum.Paper;
    if (/book/.test(path)) return SourceIdEnum.Book;
    if (/coaching/.test(path)) return SourceIdEnum.Coaching;
    if (/counselling/.test(path)) return SourceIdEnum.Counselling;
    if (/franchise/.test(path)) return SourceIdEnum.Franchisee;
    if (/expert|teacher/.test(path)) return SourceIdEnum.Expert;
    if (/mind-map/.test(path)) return SourceIdEnum.MindMap;
    if (/youtube/.test(path)) return SourceIdEnum.Youtube;
    if (/icat/.test(path)) return SourceIdEnum.ICatData;
    if (/juniorhacker/.test(path)) return SourceIdEnum.JuniorHackerOrganic;
    if (/nri/.test(path)) return SourceIdEnum.NRI;
    if (/blog/.test(path)) return SourceIdEnum.BlogUser;
    if (/^\/$|^\/home\/?$/.test(path)) return SourceIdEnum.WebHome;
    if (/^\/dashboard|^\/user\//.test(path)) return SourceIdEnum.Login;

    return SourceIdEnum.CMSDefault;
  }
}
